import {
  Alert,
  Button,
  InputNumber,
  Select,
  Table,
  notification,
} from "antd";
import { useContext, useEffect, useState } from "react";

import "../styles.css";

import { Context } from "../../../context";
import { Fetch } from "../../../fetch";
import { convertIdToKey } from "../../../utils";
import { putSeriesCoinFields } from "../coinsApi";

const { Column } = Table;
const { Option } = Select;

const EpisodeCoins = () => {
  const { token, apiUrl } = useContext(Context);

  const [series, setSeries] = useState([]);
  const [seriesId, setSeriesId] = useState();
  const [episodes, setEpisodes] = useState([]);
  const [overrides, setOverrides] = useState({});
  const [seriesCoinPrice, setSeriesCoinPrice] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    Fetch(`${apiUrl}/v4/webseries?filterBy=all`, token, (result) => {
      setSeries(convertIdToKey(result?.webseries || []));
    });
  }, [apiUrl, token]);

  const handleSeriesChange = (id) => {
    setSeriesId(id);
    setEpisodes([]);
    setOverrides({});
    setSeriesCoinPrice(null);

    if (!id) {
      return;
    }

    Fetch(`${apiUrl}/episodes?series_id=${id}&filterBy=all`, token, (result) => {
      const episodes = convertIdToKey(result?.episodes || []);
      episodes.sort((a, b) => (a.episodeNo || 0) - (b.episodeNo || 0));
      setEpisodes(episodes);
    });

    Fetch(`${apiUrl}/v4/webseries/${id}?admin=${true}`, token, (result) => {
      if (result && result.success !== false) {
        setOverrides(result.episodeCoinOverrides || {});
        setSeriesCoinPrice(result.coinPrice ?? null);
      }
    });
  };

  const handleOverrideChange = (episodeNo, value) => {
    setOverrides((prev) => ({ ...prev, [String(episodeNo)]: value }));
  };

  const handleSave = () => {
    // Empty override = remove key from the map.
    const episodeCoinOverrides = {};
    Object.entries(overrides).forEach(([episodeNo, value]) => {
      if (value != null && value !== "") {
        episodeCoinOverrides[episodeNo] = Number(value);
      }
    });

    setSaving(true);
    putSeriesCoinFields(
      apiUrl,
      token,
      seriesId,
      { episodeCoinOverrides },
      (result) => {
        setSaving(false);
        if (result.success) {
          notification.success({
            message: "Success",
            description: "Episode coin overrides updated",
          });
          setOverrides(episodeCoinOverrides);
        } else {
          notification.error({
            message: "Error updating episode coin overrides",
            description: "Check console for more details",
          });
        }
      },
      () => {
        setSaving(false);
        notification.error({
          message: "Error updating episode coin overrides",
          description: "Check console for more details",
        });
      }
    );
  };

  return (
    <div className="manage-tasks-wrapper">
      <Alert
        className="manage-tasks-caption"
        type="info"
        showIcon
        message="Overrides the series-level coin price for a single episode. Episode-level unlock enforcement ships later — data is stored now."
      />
      <div className="manage-tasks-toolbar">
        <Select
          placeholder="Select a series"
          showSearch
          allowClear
          value={seriesId}
          onChange={handleSeriesChange}
          optionFilterProp="children"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {series.map((s) => (
            <Option key={s.key} value={s.key}>
              {s.title}
            </Option>
          ))}
        </Select>
        <Button
          type="primary"
          onClick={handleSave}
          disabled={!seriesId}
          loading={saving}
        >
          Save Overrides
        </Button>
      </div>
      <Table dataSource={episodes}>
        <Column
          title="Episode No"
          dataIndex="episodeNo"
          key="episodeNo"
          align="center"
        />
        <Column title="Title" dataIndex="title" key="title" align="center" />
        <Column
          title="Series Coin Price"
          key="seriesCoinPrice"
          align="center"
          render={() => seriesCoinPrice ?? "-"}
        />
        <Column
          title="Coin Override"
          key="coinOverride"
          align="center"
          render={(text, record) => (
            <InputNumber
              min={0}
              precision={0}
              placeholder="No override"
              value={overrides[String(record.episodeNo)] ?? null}
              onChange={(value) =>
                handleOverrideChange(record.episodeNo, value)
              }
            />
          )}
        />
      </Table>
    </div>
  );
};

export default EpisodeCoins;
